import React from 'react';
import PropTypes from 'prop-types';
import { startCase } from '../../utils';
import { Types } from '../helpers';
import classnames from 'classnames';
var propTypes = {
  column: Types.column.isRequired,
  sortPath: PropTypes.string,
  ascending: PropTypes.bool.isRequired,
  onClick: PropTypes.func
};
function TableHeader(_ref) {
  var _ref$column = _ref.column,
    name = _ref$column.name,
    label = _ref$column.label,
    disabled = _ref$column.disabled,
    sortPath = _ref.sortPath,
    ascending = _ref.ascending,
    onClick = _ref.onClick;
  var active = sortPath === name;
  var arrowClass = getArrowClass(active, ascending);
  return /*#__PURE__*/React.createElement("th", {
    onClick: onClick,
    className: classnames(arrowClass, {
      sortable: !disabled
    })
  }, label || startCase(name));
}
function getArrowClass(active, ascending) {
  if (!active) return '';
  return ascending ? 'order-ascend' : 'order-descend';
}
TableHeader.propTypes = propTypes;
export default TableHeader;